export default "__VITE_ASSET__CeBVZDv$__";